import * as React from 'react'

interface IProps {
  src: string
  size: number
}

export default function NetworkLogo(props: IProps) {
  const { src, size } = props

  return (
    <>
      <img src={`${src}-/resize/${size}x/-/quality/smart/`} />
      &nbsp;
    </>
  )
}
